export default __webpack_public_path__ + "static/media/illustrationsArtefacts.b6ce1513.svg";